import vue from 'vue';
import router from '../router';
import axios from 'axios';
import { store } from '@/store';
import { tokenUtil } from '@/utils/cookie';
import { localTokenUtil } from '@/utils/localStorageHelper';

export const BASE_API_DOMAIN = process.env.BASE_API;
// create an axios instance
const service = axios.create({
  baseURL: BASE_API_DOMAIN, // api 的 base_url
  timeout: 30000 // request timeout
});
// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    var token;
    if (localTokenUtil.getUsePasswordLogin()) {
      // 密码登录模式，从 localStorage 读取 token
      token = localTokenUtil.get(store.state.orgid);
    } else {
      // 默认从 cookie 读取 token
      token = tokenUtil.get(store.state.orgid);
    }
    if (token) {
      config.headers['Authorization'] = token;
    } else {
      config.headers['Authorization'] = 'Bearer *** ' + process.env.API_ENV_TAG;
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data;
    if(res && res.Message=="已拒绝为此请求授权。"){
      router.push('/');
    }
    return res;
  },
  error => {
    if (
      error.response.status === 401 ||
      error.response.status === 402 ||
      error.response.status === 403
    ) {
      // Token 过期了;
      tokenUtil.remove(store.state.orgid);
      localTokenUtil.remove(store.state.orgid);
      try {
        var xhr = new XMLHttpRequest();
        var logurl = "http://apib.test.milijiazhang.com/api/LogHelper/Log?model=Apollo.Front.Students&category=RequestError&logkey=" + store.state.orgid + "&msg=" + error.response.status
        xhr.open("GET", logurl, true);
        xhr.send();
        router.push('/');
      } catch (error) {

      }

    }
    return Promise.reject(error);
  }
);
export default function request(url, mate) {
  return service({
    method: mate.method,
    url: url,
    params: mate.params,
    data: mate.body
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js